<div class="flex flex-col min-h-screen pt-20 px-4 sm:px-10 overflow-x-hidden overflow-y-auto landing-background-image box-border">
  <div class="grid main-content w-full max-w-full">
    <div class="col-span-4 lg:col-span-5 md:col-span-12 sm:col-span-12 w-full max-w-full px-2 sm:px-0 box-border">
      <div class="text-left break-words w-full max-w-full">
        <h1 class="font-bold text-white uppercase leading-tight text-xl sm:text-3xl lg:text-6xl">The place for bringing LAUSD & contractors</h1>
        <h1 class="font-bold text-green-200 uppercase leading-tight text-xl sm:text-3xl lg:text-6xl">together!</h1>
      </div>
      <div class="w-full sm:w-4/5 pt-6 sm:pt-10 pb-6 sm:pb-10">
        <p class="sub-title text-white text-sm sm:text-lg lg:text-2xl">Your opportunity for public works contracts begins with your no obligation free registration</p>
      </div>
      <div class="mt-3">
        <div class="flex flex-row justify-center sm:justify-start space-x-4 w-full">
          <button class="text-lg text-white rounded landing-button outline-3" (click)="signUp()">Sign Up</button>
          <button class="text-lg text-white rounded landing-button" routerLink="/login">Log In</button>
        </div>
      </div>
    </div>
  </div>

  <div class="flex justify-center sm:justify-start mt-6 footer px-2 sm:px-4 w-full max-w-full box-border">
    <ul class="flex flex-wrap items-center text-white text-[9px] sm:text-sm gap-x-2 sm:gap-x-4 gap-y-1 leading-tight sm:leading-normal w-full max-w-full overflow-hidden">
      <li>
        <img src="../../assets/colbi-white.png" alt="Colbi Technologies Inc." class="h-3.5 sm:h-6" />
      </li>
      <li>&copy; 2025 Colbi Technologies Inc.™</li>
      <li>All Rights Reserved</li>
      <li><a href="/privacy-policy" target="_blank" class="hover:underline">Privacy Policy</a></li>
      <li><a href="/release-of-liability" target="_blank" class="hover:underline">Release of Liability</a></li>
      <li><a href="mailto:qbsupport@colbitech.com" target="_blank" class="hover:underline">Help</a></li>
    </ul>
  </div>
</div>
